export default __webpack_public_path__ + "static/media/03.0c76b627.png";